import angular from 'angular';
import { SignalSmoothingActions } from '@/hybrid/tools/signalSmoothing/signalSmoothing.actions';

angular.module('Sq.Investigate').service('sqSignalSmoothingActions', SignalSmoothingActions);
